import React from 'react';

const Logo = ({ size = 'default', className = '', variant = 'default' }) => {
  const dimensions = {
    small: { height: 32 },
    default: { height: 50 },
    large: { height: 65 }
  };

  const { height } = dimensions[size] || dimensions.default;

  return (
    <img
      src="/black-logo.gif"
      alt="Global Trademark USA Logo"
      style={{ 
        height: `${height}px`, 
        width: 'auto',
        maxWidth: '100%'
      }}
      className={`${className}`}
    />
  );
};

export default Logo;
